
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/forgot-password",
      function () {
        return require("private-next-pages/company/forgot-password/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/forgot-password"])
      });
    }
  